import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import React from "react";
import { LAB_TEST_REFERENCE_VALUES, isAbnormalResult } from "../../../../utils/constants/labTestReferenceValues";

const fields = [
  { key: "wbc", label: "WBC", unit: "/cumm" },
  { key: "neutrophil", label: "Neutrophil", unit: "%" },
  { key: "lymphocyte", label: "Lymphocyte", unit: "%" },
  { key: "monocyte", label: "Monocyte", unit: "%" },
  { key: "basophil", label: "Basophil", unit: "%" },
  { key: "esr", label: "ESR", unit: "mm/hr" },
  { key: "platelet", label: "Platelet", unit: "/cumm" },
  { key: "bloodGroup", label: "Blood Group", unit: "-" },
  { key: "hb", label: "HB", unit: "g/dL" },
  { key: "rbc", label: "RBC", unit: "/cumm" },
  { key: "pcv", label: "PCV", unit: "%" },
];

export default function HematologicalTestReport({ defaultValues, gender, reportTemplate }) {
  if (!defaultValues || Object.keys(defaultValues).length === 0) {
    return <p>डाटा उपलब्ध छैन</p>;
  }
  return (
    <TableContainer>
      <Table classes={{ root: "table-bordered" }} size="small" aria-label="Hematological Test">
        <TableHead classes={{ root: "align-center" }}>
          <TableRow>
            <TableCell>Test</TableCell>
            <TableCell>Result</TableCell>
            <TableCell>Reference Value</TableCell>
            <TableCell>Unit</TableCell>
          </TableRow>
        </TableHead>
        <TableBody classes={{ root: "align-center" }}>
          {fields.map(({ key, label, unit }) => (
            defaultValues[key] ? (
              <TableRow key={key}>
                <TableCell>{label}</TableCell>
                <TableCell style={isAbnormalResult(key, defaultValues[key], reportTemplate, gender) ? { fontWeight: "bold" } : {}}>
                  {defaultValues[key]}
                </TableCell>
                <TableCell>{LAB_TEST_REFERENCE_VALUES[reportTemplate]?.[key]?.reference || "-"}</TableCell>
                <TableCell>{unit}</TableCell>
              </TableRow>
            ) : null
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
